// @flow

import React, {Component} from 'react';
import {StyleSheet, View, Platform} from 'react-native'; // Added Platform
import {Button, Text} from 'trpc-react-native-ui';

import HyperText from './HyperText';
import Icon from './Icon';
import theme from '../../theme-config';

class Checkbox extends Component<Props> {
  styles = getStyles();
  MaybeTouchable: any;

  constructor(props: Props) {
    super(props);
    // Explicitly using View for non-touchable to avoid any UI library defaults
    this.MaybeTouchable = props.onPress ? Button : View;
  }

  getCheckboxStyle = () => {
    const checkboxStyle: Object[] = [];
    if (this.props.lightColors) {
      checkboxStyle.push(this.styles.lightBox);
      if (this.props.isChecked)
        checkboxStyle.push(this.styles.boxIfCheckedAndLightBox);
    } else {
      checkboxStyle.push(this.styles.box);
      if (this.props.isChecked) checkboxStyle.push(this.styles.boxIfChecked);
    }
    return checkboxStyle;
  };

  renderLabel = (label: HyperTextType, labelStyle: any) => {
    const styles = this.styles;

    if (label.url) {
      return (
        <HyperText
          key={label.text}
          url={label.url}
          style={[labelStyle, styles.hyperText]}>
          {label.text}
        </HyperText>
      );
    }
    return (
      <Text key={label.text} style={labelStyle}>
        {label.text}
      </Text>
    );
  };

  render() {
    const styles = this.styles;
    const MaybeTouchable = this.MaybeTouchable;
    const checkboxStyle = this.getCheckboxStyle();
    const labelStyle = [
      styles.label,
      this.props.lightColors && styles.lightLabel,
      this.props.isChecked && styles.labelIfChecked,
      this.props.labelStyle,
    ];
    const formattedText =
      this.props.hyperText &&
      this.props.hyperText.map(label => this.renderLabel(label, labelStyle));

    return (
      <View
        style={[styles.container, this.props.style]}>
        <MaybeTouchable
          hitSlop={{top: 15, bottom: 15, left: 15, right: 15}}
          onPress={this.props.onPress}
          testID={this.props.testID}
          // Fix for Web: Ensure the button wrapper is transparent and has no padding/border
          style={styles.touchableWrapper}
          transparent={Platform.OS === 'web'} // Pass through if library supports it
        >
          <Icon
            name={
              this.props.isChecked ? 'checkbox-checked' : 'checkbox-unchecked'
            }
            size={20}
            style={[checkboxStyle, styles.iconTransparent]} // Forced transparency
          />
        </MaybeTouchable>
        <Text style={styles.baseText}>
          {this.props.text && <Text style={labelStyle}>{this.props.text}</Text>}
          {formattedText}
        </Text>
      </View>
    );
  }
}

function getStyles() {
  return StyleSheet.create({
    container: {
      backgroundColor: 'transparent',
      flexDirection: 'row',
      alignItems: 'center', // Added to keep icon and text aligned
    },
    // New style to strip web button defaults
    touchableWrapper: {
      backgroundColor: 'transparent',
      borderWidth: 0,
      padding: 0,
      margin: 0,
      ...Platform.select({
        web: {
          outlineStyle: 'none',
          boxShadow: 'none',
        }
      })
    },
    iconTransparent: {
      backgroundColor: 'transparent',
    },
    box: {
      color: theme.checkboxColor,
      opacity: 1,
    },
    lightBox: {
      color: theme.checkboxColor,
      opacity: 1,
    },
    boxIfChecked: {
      opacity: 1,
    },
    boxIfCheckedAndLightBox: {
      color: theme.selectedCheckboxColor,
    },
    label: {
      color: theme.checkboxTextColor,
      backgroundColor: 'transparent', // Added
    },
    lightLabel: {
      color: theme.checkboxTextColor,
      backgroundColor: 'transparent', // Added
    },
    labelIfChecked: {
      opacity: 1,
    },
    baseText: {
      opacity: 1,
      fontSize: 17,
      width: 300,
      textAlign: 'justify',
      marginLeft: 15,
      flex: 1,
      backgroundColor: 'transparent', // Added
    },
    hyperText: {
      fontWeight: '500',
    },
  });
}

type Props = {
  hyperText?: HyperTextType[],
  text?: string,
  onPress: Function,
  isChecked: boolean,
  style?: any,
  lightColors?: boolean,
  labelStyle?: Object,
  testID?: string,
};

type HyperTextType = {
  text: string,
  url?: string,
};

export default Checkbox;